// src/styles/variables.js
export const colores = {
    rojo: 'red',
    verde: '#269c42f5',
    blanco: 'white',
    negro: 'black',
    grisClaro: 'lightgray',
    textoPrincipal: 'black',
    fondosModal: 'rgba(0, 0, 0, 0.5)',
    fondo: '#EAEAE4 ',
    grisOscuro: '#121212'
  }; 
  
  export const fontSizes = {
    titulo: 24,
    subtitulo: 18,
    texto: 14,
  };
  
  export const spacing = {
    sm: 8,
    md: 16,
    lg: 24,
  };

// Layout consistente para toda la web
export const layout = {
  // Padding lateral para alineación consistente en toda la web
  contentPadding: 65, // padding en px para desktop
  contentPaddingMobile: 16, // padding en px para móvil
  // Ancho máximo del contenido principal
  maxContentWidth: 1400,
};

  
  export const fuentes = {
    regular: 'Montserrat-Regular',
    bold: 'Montserrat-Bold',
    semiBold: 'Montserrat-SemiBold',
    medium: 'Montserrat-Medium',
    italic: 'Montserrat-Italic',
    light: 'Montserrat-Light',
  };
